/**
 * Dashboard in-page links (#2167, #2208): a name in the Month view scrolls
 * to its budget group or ledger row further down the page. The app bar is
 * sticky, so the target sits its rendered height (44px on md+, two rows
 * below md) plus a small gap below the top of the viewport; scrollIntoView
 * would tuck it underneath.
 */

const SCROLL_GAP_PX = 8;
const FLASH_MS = 1400;

const scrollBelowBar = (el) => {
  const bar = document.querySelector('header.MuiAppBar-root');
  const barHeight = bar ? bar.getBoundingClientRect().height : 0;
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - barHeight - SCROLL_GAP_PX, behavior: 'smooth' });
};

// A collapsed group opens first, so the scroll never lands on a closed
// header. True when it was closed.
const openGroup = (group) => {
  const closedHeader = group.querySelector(':scope > button[aria-expanded="false"]');
  if (closedHeader) closedHeader.click();
  return Boolean(closedHeader);
};

/** Scroll to a Budgets group (DashboardBudgetGroups marks each with data-dashboard-budget-group). */
export const scrollToBudgetGroup = (key) => {
  const group = document.querySelector(`[data-dashboard-budget-group="${key}"]`);
  if (!group) return;
  openGroup(group);
  scrollBelowBar(group);
};

/**
 * Scroll to a ledger's row in Ledgers (data-dashboard-ledger) and flash it
 * so the eye finds it. A closed group's rows are unmounted, so the group
 * opens first and the row is looked up on the next frame.
 * @param {string} ledgerId
 * @param {number} type        the ledger's type, which names its group
 * @param {string} flashColor  the flash's starting background
 * @param {string} easing      a CSS easing
 */
export const scrollToLedger = (ledgerId, type, flashColor, easing) => {
  const find = () => document.querySelector(`[data-dashboard-ledger="${ledgerId}"]`);
  const go = (row) => {
    if (!row) return;
    scrollBelowBar(row);
    row.animate?.(
      [{ backgroundColor: flashColor }, { backgroundColor: flashColor, offset: 0.4 }, { backgroundColor: 'transparent' }],
      { duration: FLASH_MS, easing },
    );
  };
  const row = find();
  if (row) {
    go(row);
    return;
  }
  const group = document.querySelector(`[data-dashboard-ledger-group="${type}"]`);
  if (group && openGroup(group)) requestAnimationFrame(() => go(find()));
};
